import { render, staticRenderFns } from "./ParentsTuteurs.vue?vue&type=template&id=76381970&scoped=true"
import script from "./ParentsTuteurs.vue?vue&type=script&lang=js"
export * from "./ParentsTuteurs.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/DemandeBourse.css?vue&type=style&index=0&id=76381970&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76381970",
  null
  
)

export default component.exports